/** Card design variant (1–9) mapping to front/back image paths */
export type CardVariant = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export const TOTAL_CARD_VARIANTS = 9;

interface CardDesign {
  front: string;
  back: string;
}

const CARD_DESIGNS: Record<CardVariant, CardDesign> = {
  1: {
    front: "/cards/Prepaid card- variation1-front.png",
    back: "/cards/Prepaid card- variation1-back.png",
  },
  2: {
    front: "/cards/Prepaid card- variation2-front.png",
    back: "/cards/Prepaid card- variation2-back.png",
  },
  3: {
    front: "/cards/Prepaid card- variation3-front.png",
    back: "/cards/Prepaid card- variation3-back.png",
  },
  4: {
    front: "/cards/Prepaid card- variation4-front.png",
    back: "/cards/Prepaid card- variation4-back.png",
  },
  5: {
    front: "/cards/Prepaid card- variation5-front.png",
    back: "/cards/Prepaid card- variation5-back.png",
  },
  6: {
    front: "/cards/Prepaid card- variation6-front.png",
    back: "/cards/Prepaid card- variation6-back.png",
  },
  7: {
    front: "/cards/Prepaid card- variation7-front.png",
    back: "/cards/Prepaid card- variation7-back.png",
  },
  8: {
    front: "/cards/Prepaid card- variation8-front.png",
    back: "/cards/Prepaid card- variation8-back.png",
  },
  9: {
    front: "/cards/Prepaid card- Variation9-front.png",
    back: "/cards/Prepaid card- Variation9-back.png",
  },
};

/** Get front and back image paths for a given card variant */
export function getCardDesign(variant: CardVariant): CardDesign {
  return CARD_DESIGNS[variant];
}

/** Get a variant number from an index (cycles through 1–9) */
export function getVariantFromIndex(index: number): CardVariant {
  return ((index % TOTAL_CARD_VARIANTS) + 1) as CardVariant;
}

/** Get a consistent variant from a card/entity ID string */
export function getVariantFromId(id: string): CardVariant {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
  }
  return (((Math.abs(hash) % TOTAL_CARD_VARIANTS)) + 1) as CardVariant;
}
